import React from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
import { connect } from 'react-redux'
import { routeTo, scrollTop } from '@brainstud/react-helpers'
import { withModal } from '@brainstud/react-tbl/features/modals'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'

class IndexView extends React.Component {
  componentDidMount() {
    if(!this.props.navItem) return

    this.props.app.closeSidebar()
    this.props.app.closeGlobalMap()
    this.props.modal.close()
    this.props.app.setCurrentTheme(this.props.navItem.theme)
    scrollTop()
  }
  componentDidUpdate(props) {
    if(!this.props.navItem) return

    if(props.location.pathname !== this.props.location.pathname) {
      this.props.app.setCurrentTheme(this.props.navItem.theme)
      this.props.app.closeSidebar()
      this.props.app.closeGlobalMap()
      this.props.modal.close()
      scrollTop()
    }
  }

  render() {
    if(!this.props.navItem)
      return <Redirect to={routeTo(appRoutes, 'home')} />

    return this.props.children
  }
}

export default withRouter(withApp(withModal(connect(
  (state, props) => {
    const navigation = state.navigation.list.byId
    const navItem = Object.values(navigation).find(item => item[`${props.type}Id`] === props.id)

    return { navItem }
  },
  () => ({}),
)(IndexView))))
